import {
  createFileRoute,
  Link,
  Outlet,
  redirect,
  useLocation,
} from '@tanstack/react-router';
import {
  CircleArrowLeft,
  DoorOpen,
  MapPin,
  PersonStanding,
  Tag,
  Users,
} from 'lucide-react';
import { UserRoles } from '~entities/users';

import { TabList, type TabListItem } from '~shared/components/tab-list';
import { checkMinRoleValue } from '~shared/utils/role-guard';

const PendingComponent = () => {
  return (
    <div className='flex h-screen items-center justify-center'>Loading....</div>
  );
};

export const Route = createFileRoute('/_auth/_layout/category-config')({
  beforeLoad: async () => {
    const hasAccess = await checkMinRoleValue(UserRoles.ADMIN);
    if (!hasAccess) {
      return redirect({
        to: '/dashboard',
      });
    }
  },
  pendingComponent: PendingComponent,
  component: RouteComponent,
});

function RouteComponent() {
  const { pathname } = useLocation();

  const tabsList = getTabsList(pathname);

  return (
    <div className=''>
      <Link to='/dashboard' className='flex w-fit min-w-0 items-center gap-2'>
        <CircleArrowLeft className='size-6 shrink-0' />
        <h2 className='truncate text-xl font-semibold sm:text-2xl'>
          Class Management
        </h2>
      </Link>
      <div className='mt-4 border-t pt-6'>
        <div className='border-b border-border'>
          <TabList tabList={tabsList} />
        </div>
        <div className='mt-8'>
          <Outlet />
        </div>
      </div>
    </div>
  );
}

function getTabsList(pathname: string): Array<TabListItem> {
  const locationPattern = 'locations';
  const roomPathPattern = 'rooms';
  const instructorPathPattern = 'instructors';
  const groupPathPattern = 'groups';
  const tagPathPattern = 'tags';

  return [
    {
      href: `/category-config/groups`,
      label: 'Groups',
      active: pathname.includes(groupPathPattern),
      icon: Users,
    },
    {
      href: `/category-config/instructors`,
      label: 'Instructors',
      active: pathname.includes(instructorPathPattern),
      icon: PersonStanding,
    },
    {
      href: `/category-config/locations`,
      label: 'Locations',
      active: pathname.includes(locationPattern),
      icon: MapPin,
    },
    {
      href: `/category-config/rooms`,
      label: 'Rooms',
      active: pathname.includes(roomPathPattern),
      icon: DoorOpen,
    },
    {
      href: `/category-config/tags`,
      label: 'Tags',
      active: pathname.includes(tagPathPattern),
      icon: Tag,
    },
  ];
}
